<app-basic-select [options]="permissionNames" [(ngModel)]="localValue" [iconClass]="'toggles fw-semibold'" [title]="title" (ngModelChange)="onValueChange($event)"></app-basic-select>
